// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3ptoR","header":"Messages_header__14j1v"};